var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.1665 16.9833H29.3498C25.3998 16.9833 22.1832 13.7666 22.1832 9.81665V4.99998C22.1832 4.08331 21.4332 3.33331 20.5165 3.33331H13.4498C8.3165 3.33331 4.1665 6.66665 4.1665 12.6166V27.3833C4.1665 33.3333 8.3165 36.6666 13.4498 36.6666H26.5498C31.6832 36.6666 35.8332 33.3333 35.8332 27.3833V18.65C35.8332 17.7333 35.0832 16.9833 34.1665 16.9833Z",
    fill: "#FF4378"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3335 3.68334C25.6501 3.00001 24.4668 3.46668 24.4668 4.41668V10.2333C24.4668 12.6667 26.5335 14.6833 29.0501 14.6833C30.6335 14.7 32.8335 14.7 34.7168 14.7C35.6668 14.7 36.1668 13.5833 35.5001 12.9167C33.1001 10.5 28.8001 6.15001 26.3335 3.68334Z",
    fill: "#FF4378"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22.9167H12.5C11.8167 22.9167 11.25 22.35 11.25 21.6667C11.25 20.9834 11.8167 20.4167 12.5 20.4167H22.5C23.1833 20.4167 23.75 20.9834 23.75 21.6667C23.75 22.35 23.1833 22.9167 22.5 22.9167Z",
    fill: "#FF4378"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 29.5833H12.5C11.8167 29.5833 11.25 29.0166 11.25 28.3333C11.25 27.65 11.8167 27.0833 12.5 27.0833H19.1667C19.85 27.0833 20.4167 27.65 20.4167 28.3333C20.4167 29.0166 19.85 29.5833 19.1667 29.5833Z",
    fill: "#FF4378"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.3cceee0f5a8fb0b413052351c6500a88.svg";
export { ForwardRef as ReactComponent };